<template>
  <div
    class="mb-4 mt-4 flex flex-wrap gap-4 first:mt-0 md:mt-12 md:flex-nowrap"
  >
    <WebccButton
      v-if="!$params.iframe"
      variant="theme"
      size="md"
      class="md:hidden"
      icon="site/menu"
      @click.stop="useToggler().toggle('sidemenu')"
    >
      <span>{{ $t(`${trPrefix}menu`) }}</span>
    </WebccButton>

    <div
      v-if="!$params.iframe"
      :class="useToggler().toggles('sidemenu') ? 'block' : 'hidden'"
      class="w-full md:block md:w-1/3"
    >
      <ul
        v-for="section in block.content.menu.content.contentPagesMenu"
        :key="section.name"
      >
        <WebccLink
          class="block border-l-2 border-solid bg-bgr-100 px-3 py-2 font-semibold hover:bg-bgr-400 hover:text-txt-contrast"
          :class="
            active(section.url) ? 'border-bgr-400 text-thm' : 'border-bgr-100'
          "
          :to="section.url"
          >{{ section.name }}</WebccLink
        >
        <li v-for="item in section.children" :key="item.name">
          <WebccLink
            class="block border-l-2 border-solid px-3 py-2 hover:border-bgr-400 hover:bg-bgr-400 hover:text-txt-contrast"
            :class="
              active(item.url) ? 'border-bgr-400 text-thm' : 'border-bgr-100'
            "
            :to="item.url"
            >{{ item.name }}</WebccLink
          >
        </li>
      </ul>
    </div>
    <div class="w-full md:w-2/3">
      <Blocks :blocks="block.content.content" />
    </div>
  </div>
</template>

<script setup lang="ts">
const trPrefix = 'www.components.views.PageContent.'

defineProps<{ block: Block<MenuBlockContent> }>()

function active(url: string) {
  // TODO: This triggers a warning, but I was not able to find a solution up until now.
  return url === useRoute().path
}
</script>
